/**
 * @flow
 * @relayHash 5bebc8be07c4c6b3015b49e79e5d6e01
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateIntegrationInput = {|
  id: string,
  isEnabled?: ?boolean,
  metadata?: ?any,
  rawMetadata?: ?any,
|};
export type UpdateIntegrationMutationVariables = {|
  input: UpdateIntegrationInput
|};
export type UpdateIntegrationMutationResponse = {|
  +updateIntegration: {|
    +integrationEdge: {|
      +node: {|
        +id: string,
        +isEnabled: boolean,
        +source: {|
          +id: string,
          +name: string,
          +description: ?string,
          +logo: ?string,
        |},
      |}
    |}
  |}
|};
export type UpdateIntegrationMutation = {|
  variables: UpdateIntegrationMutationVariables,
  response: UpdateIntegrationMutationResponse,
|};
*/


/*
mutation UpdateIntegrationMutation(
  $input: UpdateIntegrationInput!
) {
  updateIntegration(input: $input) {
    integrationEdge {
      node {
        id
        isEnabled
        source {
          id
          name
          description
          logo
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateIntegrationInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateIntegration",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "integrationEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "IntegrationEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Integration",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isEnabled",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "source",
                "storageKey": null,
                "args": null,
                "concreteType": "IntegrationSource",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logo",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateIntegrationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateIntegrationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateIntegrationMutation",
    "id": null,
    "text": "mutation UpdateIntegrationMutation(\n  $input: UpdateIntegrationInput!\n) {\n  updateIntegration(input: $input) {\n    integrationEdge {\n      node {\n        id\n        isEnabled\n        source {\n          id\n          name\n          description\n          logo\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9d9a67f314a4848c65c9285e03424203';
module.exports = node;
